<div class="actions">
  <div class="action" *ngFor="let actionButton of actionButtons;  let i = index">
    <mat-icon  [ngClass]="actionButton['hoverColor']" [matTooltip]="actionButton.tooltip"
      (click)="actionTriggeredHandler($event, i)">
      {{actionButton['icon']}}
    </mat-icon>
  </div>
</div>